// extracted by mini-css-extract-plugin
export default {"fields":"GeneralInformationFields_fields__QHZa7"};